import _ from 'lodash';
import moment from 'moment';
import { GRANULARITY_TYPES } from '../Header/GranularityToggler';

const getRangeDiff = (startDate, endDate, durationUnit) =>
  _.ceil(
    moment(endDate)
      .endOf('day')
      .diff(moment(startDate).startOf('day'), durationUnit, true),
    1
  );

const useGraphCategories = ({ data, granularity }) => {
  const orderedPeriods = _.orderBy(
    data,
    item => _.get(item, 'allocation_data', []).length,
    'desc'
  );
  const periods = _.get(orderedPeriods, '[0].allocation_data', []).map(
    item => ({
      startPeriod: _.get(item, 'start_period'),
      endPeriod: _.get(item, 'end_period')
    })
  );

  const mapGranularityToCategories = {
    [GRANULARITY_TYPES.MONTHLY.key]: () => {
      return periods.map(({ startPeriod, endPeriod }) => {
        const monthDiff = getRangeDiff(startPeriod, endPeriod, 'months');

        return {
          title: moment(startPeriod).format('MMM'),
          isPartial: monthDiff < 1
        };
      });
    },
    [GRANULARITY_TYPES.WEEKLY.key]: () => {
      return periods.map(({ startPeriod, endPeriod }) => {
        const weekDiff = getRangeDiff(startPeriod, endPeriod, 'weeks');

        return {
          title: `Week ${moment(startPeriod).startOf('isoWeek').week()}`,
          isPartial: weekDiff < 1
        };
      });
    }
  };

  return mapGranularityToCategories[granularity.key]();
};

export default useGraphCategories;
